export enum eOccupancyType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  INVESTMENT = 'INVESTMENT',
}

export const DisplayOccupancyType = {
  [eOccupancyType.PRIMARY]: 'Primary',
  [eOccupancyType.SECONDARY]: 'Secondary',
  [eOccupancyType.INVESTMENT]: 'Investment',
};
